<template>
  <div class="main">
    <my_menu2 page_name="数据完善看板" back_type="close" back_icon="md-close"></my_menu2>
    <div style="height:50px;"></div>
    <div class="content">
      <Tabs type="card" v-model="dep_1" @on-click="dep_click_1">
        <TabPane
          :name="item.value"
          :label="item.label"
          v-for="(item, i) in dep_list"
          :key="i"
        >
          <div class="tabs_dep">
            <Tabs v-model="dep_2" @on-click="dep_click_2">
              <TabPane
                :name="dep_item.value"
                :label="dep_item.label"
                v-for="(dep_item, dep_index) in item.children"
                :key="dep_index"
              ></TabPane>
            </Tabs>
          </div>
        </TabPane>
      </Tabs>
      <div class="table_div">
        <Spin fix v-if="loading">
          <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
          <div>正在加载中</div>
        </Spin>
        <Table
          :columns="columns"
          :data="table_data"
          size="small"
          :height="windowHeight - 200"
          show-summary
        >
          <template #kefu="{ row }">
            <div>
              <span v-for="(item, i) in row.kefu" :key="i"> {{ item }}, </span>
            </div>
          </template>
          <template #weiwanshan_count="{ row }">
            <div>
              <span class="weiwanshan_count" @click="click_show_weiwanshan(row)">{{
                row.weiwanshan_count
              }}</span>
            </div>
          </template>
        </Table>
      </div>
      <!-- <span >{{ query_date[0].getMonth() }}{{ query_date[1].getMonth() }}数据跨月，本月数据列已隐藏</span> -->
    </div>
  </div>
</template>

<script>
import my_menu2 from "@/component/menu/menu2.vue";
import { http, open_new_page } from "@/utils/http.js";
import { Row } from "view-ui-plus";

export default {
  components: {
    my_menu2,
  },
  data() {
    return {
      windowHeight: document.documentElement.clientHeight,

      //部门数据
      dep_list: [],
      dep_1: "",
      dep_2: "",

      table_data: [],
      columns: [],

      loading: false,
    };
  },
  mounted() {
    this.get_dep_options();
  },
  methods: {
    click_show_weiwanshan(item) {
      console.log(item);
      this.$Modal.confirm({
        title: "未完善人员详情",
        content: "<p>" + String(item.weiwanshan_list) + "</p>",
        onOk: () => {},
        onCancel: () => {},
      });
    },
    get_dep_options() {
      var that = this;
      var obj = {};
      http(
        "post",
        process.env.VUE_APP_HOST + "/data_panel/wanshan/dep_options",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.dep_list = res.data.data_list;

            if (that.dep_list.length == 0) {
              this.$Message.info("当前没有可用的项目权限");
              this.page_auth_show = false;

              return;
            } else {
              this.page_auth_show = true;
              this.dep_1 = that.dep_list[0]["value"];
              this.dep_2 = that.dep_list[0]["children"][0]["value"];
              this.get_wanshan_data();
            }
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },
    dep_click_1(e) {
      this.dep_1 = e;
      for (let i = 0; i < this.dep_list.length; i++) {
        var dep_id = this.dep_list[i]["value"];
        if (dep_id == e) {
          this.dep_2 = this.dep_list[i]["children"][0]["value"];
          console.log(this.dep_2);
          this.get_wanshan_data();

          return;
        }
      }
    },
    //点击部门
    dep_click_2(e) {
      this.get_wanshan_data();
    },

    // 获取完善数据
    get_wanshan_data() {
      console.log(this.dep_1, this.dep_2);
      var that = this;
      var obj = {
        dep_team_id: this.dep_1,
        dep_id: this.dep_2,
      };
      that.loading = true;
      http(
        "post",
        process.env.VUE_APP_HOST + "/data_panel/wanshan/dep_wanshan_data",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.table_data = res.data.table_data;
            that.columns = res.data.columns;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.loading = false;
        })
        .catch((res) => {
          that.loading = false;

          console.log(res, "请求出错");
        });
    },
  },
};
</script>

<style scoped>
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.table_div {
  position: relative;
}

.weiwanshan_count {
  color: #0466dd;
  cursor: pointer;
}

.content {
  background-color: #fff;
  margin: 0 10px 10px 10px;
  height: calc(100vh - 60px);
  overflow: auto;
}
.main {
  background: #f5f7f9;
  min-height: 100vh;
}
</style>
